<template functional>
  <g>
    <!-- 空間（加工付き空間パスか色が存在する場合は非表示） -->
    <rect
      v-if="Object.keys(props.space).length && !props.spacePath && !props.colorDispTex"
      :x="props.space.x"
      :y="props.space.y"
      :width="props.space.w"
      :height="props.space.h"
      fill="white"
      :fill-opacity="$options.fillOpacity(props.space)"
      :stroke="$options.stroke(props.space, props.dxfFace)"
      :stroke-dasharray="$options.strokeDasharray(props.space, props.addTargetSpaceId, props.editTargetCellSpaceParentId)"
      :stroke-width="props.strokeWidth"
      :data-front-position="props.space.z + props.space.d"
      :data-parent-id="props.space.parentSpaceId"
    />

    <!-- 加工付き空間パス -->
    <path
      v-if="props.spacePath"
      :d="props.spacePath"
      :transform="$options.spacePathTransform(props.space)"
      fill="white"
      :fill-opacity="$options.fillOpacity(props.space)"
      :stroke="$options.stroke(props.space, props.dxfFace)"
      :stroke-width="props.strokeWidth"
      :data-front-position="props.space.z + props.space.d"
      :data-parent-id="props.space.parentSpaceId"
    />

    <!-- 色（テクスチャー画像）のタイル張りの定義 -->
    <defs v-if="props.colorDispTex">
      <pattern
        :id="'color-tex-pattern-' + props.viewType.code + '-' + props.space.id"
        :x="props.space.x"
        :y="props.space.y"
        :width="props.colorDispTexSize.width"
        :height="props.colorDispTexSize.height"
        patternUnits="userSpaceOnUse"
      >
        <image :href="props.colorDispTex"/>
      </pattern>
    </defs>

    <!-- 色（テクスチャー画像） -->
    <rect
      v-if="props.colorDispTex"
      :x="props.space.x"
      :y="props.space.y"
      :width="props.space.w"
      :height="props.space.h"
      :style="'fill:' + 'url(#color-tex-pattern-' + props.viewType.code + '-' + props.space.id + ')'"
    />

    <template v-if="props.isDispProcess">
      <!-- 加工 -->
      <rect
        v-for="(process, idx) in props.ownProcessList"
        :key="'pd-' + idx + '-' + process.pdId"
        :x="process.x"
        :y="process.y"
        :rx="process.pdRx"
        :ry="process.pdRy"
        :width="process.pdW"
        :height="process.pdH"
        :stroke-width="props.scaleStrokeWidth($options.processLine(process.focusFlg).width)"
        :storoke-dasharray="$options.processLine(process.focusFlg).dasharray"
        :stroke="$options.processLine(process.focusFlg).color"
        fill-opacity="0"
      />

      <!-- 加工DXFフェイスパス -->
      <path
        v-for="(process, idx) in $options.ownProcessDxfList(props.viewType,
          props.strokeWidth, props.ownProcessList, $options.getPathSize(),
          $options.getProcessDxfPathPos(props.space))"
        :key="'pf-' + idx + '-' + process.pdId"
        :d="process.dxfFace.pathData"
        :transform="process.transform"
        :stroke-width='process.strokeWidth'
        :storoke-dasharray="$options.processLine().dasharray"
        :stroke="$options.processLine().color"
        fill='transparent'
      />
    </template>

    <!-- 空間DXFフェイスパス -->
    <path
      v-if="Object.keys(props.dxfFace).length"
      :d="props.dxfFace.pathData"
      :transform="$options.dxfPathTransform($options.dxfPathPos(props.space,
        props.pathSize, props.dxfFace), props.pathSize)"
      :stroke-width='$options.dxfPathStrokeWidth(props.strokeWidth, props.pathSize)'
      stroke='black'
      fill='transparent'
    />

    <!-- 可動棚線 -->
    <g v-if="props.showInfillLine"
      :stroke-width="props.scaleStrokeWidth($options.infillLine().width)"
      :stroke-dasharray="$options.infillLine().dasharray"
      :stroke="$options.infillLine().color"
      fill="none">
      <path :d="'M ' + $options.svgSpaceCenter(props.space) + ' v 30 l 10 -20'" />
      <path :d="'M ' + $options.svgSpaceCenter(props.space) + ' v -30 l -10 20'" />
    </g>

    <!-- アクセサリークロス線 -->
    <g
      v-if="props.isDispAccessoryCross"
      :stroke-width="props.strokeWidth"
      :stroke-dasharray="$options.strokeDasharray(props.space, props.addTargetSpaceId, props.editTargetCellSpaceParentId)"
      :stroke="$options.stroke(props.space, props.dxfFace)"
      fill="none"
    >
      <g v-if="$options.isAccessory(props.viewType)">
        <g transform="scale(1,-1)">
          <image :href="props.accessoryImg"
            v-bind:style="{x: props.space.x, y: -(props.space.y + props.space.h),
            width: props.space.w, height: props.space.h, preserveAspectRatio:'none'}"/>
        </g>
      </g>
      <g v-else>
        <line :x1="props.space.x" :y1="props.space.y" :x2="props.space.x + props.space.w" :y2="props.space.y + props.space.h" />
        <line :x1="props.space.x" :y1="props.space.y + props.space.h" :x2="props.space.x + props.space.w" :y2="props.space.y" />
      </g>
    </g>
  </g>
</template>

<script>
import * as FaceUtil from '../../../utils/Face'
import {SVG_LINE} from '../../../constants/App'
import {OBJECT_TYPE, PLANNING_TYPE, VIEW_TYPE} from '../../../constants/Type'
export default {
  name: 'DispSpace',
  props: {
    /** 対象空間 */
    space: Object,
    /** 空間パス */
    spacePath: String,
    /** カラー表示テクスチャ */
    colorDispTex: String,
    /** 空間DXFフェイス */
    dxfFace: Object,
    /** 追加対象空間データID */
    addTargetSpaceId: Number,
    /** 編集対象親セル空間ID */
    editTargetCellSpaceParentId: Number,
    /** 線の太さ */
    strokeWidth: Number,
    /** ビュー種別のタイプ */
    viewType: Object, // Type.VIEW_TYPE
    /** カラー表示テクスチャサイズ */
    colorDispTexSize: Object,
    /** 加工線を表示するか */
    isDispProcess: Boolean,
    /** 自空間の加工線リスト */
    ownProcessList: Array,
    /** 縮尺に応じた線の太さを返す */
    scaleStrokeWidth: Function,
    pathSize: Object,
    /** 可動棚線を表示するか */
    showInfillLine: Boolean,
    /** アクセサリーのクロス線を表示するか */
    isDispAccessoryCross: Boolean,
    /** アクセサリーのイメージ画像 */
    accessoryImg: String
  },
  fillOpacity ({ spaceObjectType }) {
    switch (spaceObjectType) {
      case OBJECT_TYPE.UNIT.code:
      case OBJECT_TYPE.COMBINE.code:
      case OBJECT_TYPE.ROOM.code:
      case OBJECT_TYPE.PLAN.code:
      case OBJECT_TYPE.UNITCOMPONENT.code:
      case OBJECT_TYPE.CELL.code:
      case OBJECT_TYPE.SETPLAN.code:
      case OBJECT_TYPE.SETPLAN_FIX.code:
        return '0.0'
      default:
    }
    return '1.0'
  },
  stroke ({ spaceObjectType, planningType }, dxfFace) {
    switch (spaceObjectType) {
      case OBJECT_TYPE.ELEMENT.code:
        return SVG_LINE.ELEMENT.color
      case OBJECT_TYPE.CELL.code:
        return SVG_LINE.CELL.color
      case OBJECT_TYPE.COMBINE.code:
        return SVG_LINE.COMBINE.color
      case OBJECT_TYPE.UNITCOMPONENT.code:
        return SVG_LINE.UNITCOMPONENT.color
      case OBJECT_TYPE.UNIT.code:
        if (PLANNING_TYPE.ACCESSORY === planningType) {
          return SVG_LINE.ACCESSORY.color
        }
        return SVG_LINE.UNIT.color
      case OBJECT_TYPE.PARTS.code:
        return SVG_LINE.PARTS.color
      case OBJECT_TYPE.FITTING.code:
        return SVG_LINE.FITTING.color
      case OBJECT_TYPE.SETPLAN.code:
      case OBJECT_TYPE.SETPLAN_FIX.code:
        return SVG_LINE.SETPLAN.color
      case OBJECT_TYPE.ROOM.code:
        return SVG_LINE.ROOM.color
      default:
    }
    if (Object.keys(dxfFace).length) {
      return 'white'
    } else {
      return 'black'
    }
  },
  strokeDasharray ({ id: spaceId, parentSpaceId, spaceObjectType }, addTargetSpaceId, editTargetCellSpaceParentId) {
    // 種別による制御
    if (addTargetSpaceId === spaceId) {
      return SVG_LINE.SELECT_CELL.dasharray
    }
    if (editTargetCellSpaceParentId === parentSpaceId && spaceObjectType === OBJECT_TYPE.CELL.code) {
      return SVG_LINE.SELECT_CELL.dasharray
    }
    switch (spaceObjectType) {
      case OBJECT_TYPE.ELEMENT.code: return SVG_LINE.ELEMENT.dasharray
      case OBJECT_TYPE.CELL.code: return SVG_LINE.CELL.dasharray
      case OBJECT_TYPE.COMBINE.code: return SVG_LINE.COMBINE.dasharray
      case OBJECT_TYPE.UNITCOMPONENT.code: return SVG_LINE.UNITCOMPONENT.dasharray
      case OBJECT_TYPE.UNIT.code: return SVG_LINE.UNIT.dasharray
      case OBJECT_TYPE.PARTS.code: return SVG_LINE.PARTS.dasharray
      case OBJECT_TYPE.FITTING.code: return SVG_LINE.FITTING.dasharray
      case OBJECT_TYPE.ROOM.code: return SVG_LINE.ROOM.dasharray
      case OBJECT_TYPE.SETPLAN.code:
      case OBJECT_TYPE.SETPLAN_FIX.code:
        return SVG_LINE.SETPLAN.dasharray
    }
    return SVG_LINE.DEFAULT.dasharray
  },
  spacePathTransform ({ x: spaceX, y: spaceY }) {
    return 'translate(' + spaceX + ' ' + spaceY + ')'
  },
  processLine (focusFlg) {
    if (focusFlg) {
      return SVG_LINE.TARGET_PROCESS
    } else {
      return SVG_LINE.PROCESS
    }
  },
  infillLine () {
    return SVG_LINE.INFILL_LINE
  },
  ownProcessDxfList ({ code: viewTypeCode }, strokeWidth, ownProcessList, getPathSize, getProcessDxfPathPos) {
    if (ownProcessList && ownProcessList.length > 0) {
      const otherFace = FaceUtil.getOtherFace(viewTypeCode)
      const { max } = Math
      return ownProcessList
        .filter(p => p.dxfFace)
        .filter(p => p.dxfFace.faceType === viewTypeCode || p.dxfFace.faceType === otherFace)
        .map(p => {
          const pathSize = getPathSize(p.dxfFace, p)
          const { w: pathSizeW, h: pathSizeH } = pathSize
          const { x: dxfPathPosX, y: dxfPathPosY } = getProcessDxfPathPos(p, pathSize)
          return {
            ...p,
            transform: 'translate(' + dxfPathPosX + ' ' + dxfPathPosY + ') ' + 'scale(' + pathSizeW + ' ' + pathSizeH + ')',
            strokeWidth: strokeWidth / max(pathSizeW, pathSizeH)
          }
        })
    }
    return []
  },
  getPathSize () {
    return ({ fitType, width: dxfFaceWidth, height: dxfFaceHeight }, { pdW: processPdW, pdH: processPdH }) => {
      const processPdWBasedOnPdH = processPdH * (dxfFaceWidth / dxfFaceHeight)
      const processPdHBasedOnPdW = processPdW * (dxfFaceHeight / dxfFaceWidth)
      switch (fitType) {
        case 'NONE':
          return {
            w: dxfFaceWidth,
            h: dxfFaceHeight
          }
        case 'VERTICAL':
          return {
            w: processPdW * (dxfFaceWidth / dxfFaceHeight),
            h: processPdH
          }
        case 'HORIZONTAL':
          return {
            w: processPdW,
            h: processPdHBasedOnPdW
          }
        case 'INSIDE':
          if (processPdHBasedOnPdW > processPdH) {
            return {
              w: processPdWBasedOnPdH,
              h: processPdH
            }
          }
          return {
            w: processPdW,
            h: processPdHBasedOnPdW
          }
        case 'FULL':
        default:
          return {
            w: processPdW,
            h: processPdH
          }
      }
    }
  },
  dxfPathPos ({ w: spaceW, h: spaceH, x: spaceX, y: spaceY }, { w: pathSizeW, h: pathSizeH }, { originCorner }) {
    const pos = {}
    switch (originCorner) {
      case 'LT': case 'LC': case 'LB':
        pos.x = spaceX
        break
      case 'TC': case 'CC': case 'BC':
        pos.x = spaceX + (spaceW - pathSizeW) / 2
        break
      case 'RT': case 'RC': case 'RB':
        pos.x = spaceX + spaceW - pathSizeW
        break
    }
    switch (originCorner) {
      case 'LB': case 'RB': case 'BC':
        pos.y = spaceY
        break
      case 'LC': case 'CC': case 'RC':
        pos.y = spaceY + (spaceH - pathSizeH) / 2
        break
      case 'LT': case 'TC': case 'RT':
        pos.y = spaceY + spaceH - pathSizeH
        break
    }
    return pos
  },
  dxfPathTransform ({ x: dxfPathPosX, y: dxfPathPosY }, { w: pathSizeW, h: pathSizeH }) {
    return 'translate(' + dxfPathPosX + ' ' + dxfPathPosY + ') ' + 'scale(' + pathSizeW + ' ' + pathSizeH + ')'
  },
  dxfPathStrokeWidth (strokeWidth, { w: pathSizeW, h: pathSizeH }) {
    return strokeWidth / Math.max(pathSizeW, pathSizeH)
  },
  svgSpaceCenter ({ w: spaceW, h: spaceH, x: spaceX, y: spaceY }) {
    return (spaceX + spaceW / 2) + ' ' + (spaceY + spaceH / 2)
  },
  isAccessory (viewType) {
    return VIEW_TYPE.FRONT === viewType
  },
  // *****************************************************************
  // 加工のDXFフェイス表示処理
  // *****************************************************************
  getProcessDxfPathPos ({ x: spaceX, y: spaceY }) {
    return ({ pdX: processPdX, pdY: processPdY }, { w: pathSizeW, h: pathSizeH }) => {
      return {
        x: spaceX + processPdX - pathSizeW / 2,
        y: spaceY + processPdY - pathSizeH / 2
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/js/components/planning/parts/DispSpace.vue